import style from '../style/components/qrcode-order-info.module.scss'

interface Props {
  title: string
  content: string | React.ReactNode
  contentClassName?: string
  button?: React.ReactNode
}
export const QRcodeOrderInfo = (props: Props) => {
  const { title, content, contentClassName, button } = props

  return (
    <section className={style.wrapper}>
      <p className={style.title}>{title}</p>
      <p className={contentClassName || style.content}>{content}</p>
      <p>{button}</p>
    </section>
  )
}
